import { globalBackendClient } from '@mimir/client-common/globals/backendClient';
import { standardItemEntryKeys } from '@mimir/common/dto/itemModelPrimitives';
import type { StandardItemEntryDto, GetItemsDto } from '@mimir/common/dto/itemModels';
import { api_getItems } from '@mimir/client-common/api/getItemsApi';

// Search hits need mediaSize updates, but standard item fields omit it.
export const polledItemEntryKeys = [...standardItemEntryKeys, 'mediaSize'] as const;

export type PolledItemEntryDto = StandardItemEntryDto & Pick<GetItemsDto, 'mediaSize'>;

export const getItemsWithDefaultFields = async (itemIds: string[]): Promise<PolledItemEntryDto[]> =>
  api_getItems(globalBackendClient, itemIds, polledItemEntryKeys);

export const getItems = async <Key extends keyof (GetItemsDto)>(itemIds: string[], fields: Key[] | readonly Key[]): Promise<Pick<GetItemsDto, Key>[]> =>
  api_getItems(globalBackendClient, itemIds, fields);

